import { initProductOrderOption } from "./option/index.js";
import { initProductOrderTabs } from "./tabs/index.js";

function initProductOrderPage() {
    initProductOrderTabs();
    initProductOrderOption();
}

window.onload = () => {
    initProductOrderPage();
}